@if(loader){
    <app-loader></app-loader>
}
<p-card>

    <p-dataView #dv [value]="listInvoice" layout="list">

        <ng-template let-listorder pTemplate="list">
            <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
                <div class="flex align-items-center">

                    <div class="flex align-items-center ml-3">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder"
                                class=" p-inputtext-sm" (keyup.enter)="searchOrder()"
                                style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
                        </span>
                        <p-button icon="pi pi-search" (onClick)="searchOrder()"
                            [style]="{'margin': '5px 5px 5px 5px', 'height': '35px', 'line-height': '50px'}"
                            [raised]="true" [size]="'small'" severity="info"></p-button>
                    </div>

                    <div>
                        <p-button (onClick)="view()" [disabled]="selectedOrder && selectedOrder.length !== 1"
                            label="View" class="p-button-outlined ml-2 " icon="pi pi-eye" severity="secondary"
                            size="small" pTooltip="View Dispatch Order"></p-button>
                        <p-button (onClick)="delete()" [disabled]="(selectedOrder.length > 0)? false : true"
                            label="Delete" class="p-button-outlined ml-2" icon="pi pi-trash" severity="danger"
                            size="small"></p-button>

                    </div>
                </div>

            <h2 class="page-title-center">List of Dispatch Order</h2>

              <div class="flex">
                  <div class="flex align-items-center">
                      <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true" severity="info"></p-button>
                  </div>
              </div>

            </div>

            <p-table #dt1 [value]="listInvoice" [scrollable]="true" scrollHeight="613px" styleClass="p-datatable-striped" scrollHeight="630px"
                responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="10" [(selection)]="selectedOrder"
                [globalFilterFields]="['salesOrderNumber','customer.customerName']" [rowsPerPageOptions]="[10 ,15, 20]" (onPage)="loadOrderList($event)" [rowHover]="true">

                <ng-template pTemplate="header">
                    <tr>
                        <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                        <th>Order No</th>
                        <th>Date</th>
                        <th>Bill To Customer</th>
                        <!-- <th>Bill To Code </th>
                        <th>Ship To Code</th> -->
                        <th>Ship To Customer</th>
                        <th class="text-center">Order Total </th>
                        <th style="text-align: center;">Req'd Date</th>
                        <th>Order Status</th>
                        <th>Created By </th>
                        <th>Print </th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-order>
                    <tr>
                        <td> <p-tableCheckbox [value]="order"></p-tableCheckbox> </td>
                        <td class="text-blue-500 underline" style="cursor: pointer;" (click)="view(order)">{{order.salesOrderNumber}}</td>
                        <td>{{order.orderDate | date: 'dd/MM/yy'}}</td>
                        <td>{{order.customer.customerName}}</td>
                        <!-- <td>{{order.billToCustomerCode}}</td>
                        <td>{{order.shipToCustomerCode}}</td> -->
                        <td>{{order.shipToCustomerCode}}</td>
                        <td class="text-right"><span>₹ {{ order.orderTotal.toLocaleString('en-IN',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span></td>
                        <td style="text-align: center;">{{order.requestedDate | date: 'dd/MM/yy'}}</td>
                        <td [style.color]="getStatusColor(order.status)">
                            {{ order.status ? order.status.split(' - ')[0] : '' }}
                        </td>
                        <td>{{order.createdBy}}</td>
                        <td><span class="pi pi-print" style="color: rgb(0 35 255); cursor: pointer;" (click)="showReport(order)"></span></td>
                    </tr>
                </ng-template>

            </p-table>

        </ng-template>

    </p-dataView>

</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
